import {unsafeHTML} from 'lit-html/directives/unsafe-html';

/**
 * Wraps a promise in unsafeHtml for i18nIds to display correctly
 */
export const wrapUnsafeHtml = (value, always) => {
  if (window.aoflDevtools?.showI18nIds || always) {
    return (async () => unsafeHTML(await value))();
  }
  return value;
};
